type GetRenamedFilePropsType = {
  inputFile: File;
  newName: string;
};

export const getRenamedFile = ({
  inputFile,
  newName,
}: GetRenamedFilePropsType): File => {
  return new File([inputFile], newName, {
    type: inputFile.type,
    lastModified: inputFile.lastModified,
  });
};
